export const userListStyle = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    paper: {
        position: 'absolute',
        width: theme.spacing.unit * 50,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit * 4,
    },
    label: {
        color: 'grey'
    },
    container: {
        display: "flex",
        flexWrap: "wrap",
        width: 350
    },
    buttonPackage: {
        width: 300,
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: 10
    },
    search: {
        marginLeft: "21px",
    },
});


export const SubscriptionListStyle = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
         
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    pop:{
       
        maxWidth: 250,
    },
    paper: {
        position: 'absolute',
        width: 'auto',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit * 4,
    },
    label: {
        color: 'grey'
    },
    container: {
        display: "flex",
        flexWrap: "wrap",
        width: 350
    },
    buttonPackage: {
        width: 300,
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: 10
    },
    search: {
        marginLeft: "21px",
    },
});

export const QuotaListStyle = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
         
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    pop:{
       
        maxWidth: 250,
    },
    paper: {
        position: 'absolute',
        width: 'auto',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit * 4,
    },
    label: {
        color: 'grey'
    },
    container: {
        display: "flex",
        flexWrap: "wrap",
        width: 350
    },
    buttonPackage: {
        width: 300,
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: 10
    },
    search: {
        marginLeft: "21px",
    },
});

export const ProjectListStyle = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    paper: {
        position: 'absolute',
        width: 'auto',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit * 4,
    },
    label: {
        color: 'grey'
    },
    container: {
        display: "flex",
        flexWrap: "wrap",
        width: 350
    },
    buttonPackage: {
        width: 300,
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: 10
    },
    search: {
        marginLeft: "21px",
    },
});


export const fileManageListStyle = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    paper: {
        position: 'absolute',
        width: theme.spacing.unit * 50,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit * 4,
    },
    label: {
        color: 'grey'
    },
    container: {
        display: "flex",
        flexWrap: "wrap",
        width: 350
    },
    buttonPackage: {
        width: 300,
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: 10
    },
    search: {
        marginLeft: "21px",
    },
});

export const layerManageListStyle = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    paper: {
        position: 'absolute',
        width: 'auto',
        minWidth: theme.spacing.unit * 8,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit * 4,
        maxHeight: 'auto'
    },
    label: {
        color: 'grey'
    },
    container: {
        display: "flex",
        flexWrap: "wrap",
        width: 350
    },
    buttonPackage: {
        width: 300,
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: 10
    },
    search: {
        marginLeft: "21px",
    },
});

export const updateLayerStyle = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        minHeight: '500px'
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 500,
    },
    fixedButton: {
        position: 'absolute',
        bottom: '100px'
    },
    backButton: {
        marginRight: theme.spacing.unit,
    },
    instructions: {
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit,
    },
    paper: {
        position: 'absolute',
        width: 'auto',
        minWidth: theme.spacing.unit * 8,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit * 4,
        maxHeight: 'auto',
        
    },
    label: {
        color: 'grey'
    },
    container: {
        display: "flex",
        flexWrap: "wrap",
        width: 350
    },
    buttonPackage: {
        width: 300,
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: 10
    },
    search: {
        marginLeft: "21px",
    },
});

export const commonTablestyles = theme => ({
    table: {
        minWidth: 1020,
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2,
    },
});

export const changePasswordStyle = theme => ({
    root: {
        flexGrow: 1,
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    paper: {
        position: 'absolute',
        width: theme.spacing.unit * 60,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit * 4,
    },
    buttonContainer: {
        width: theme.spacing.unit * 60,
    },
    label: {
        color: 'grey'
    },
    container: {
        display: "flex",
        flexWrap: "wrap",
    },
    buttonPackage: {
        width: 300,
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: 10
    },
    search: {
        marginLeft: "21px",
    },
});


// WEBPACK FOOTER //
// ./src/utils/Style.js